import { makeRequest, makeStoreApiRoute } from '@/js/api/request-service.ts';

export type FormResponse = {
  success: boolean
};

export async function feedback(data: FormData) {
  return makeRequest<FormResponse>({
    method: 'POST',
    url: makeStoreApiRoute('forms/feedback/store'),
    data,
  });
}

export async function productAvailability(data: FormData) {
  return makeRequest<FormResponse>({
    method: 'POST',
    url: makeStoreApiRoute('forms/product/availability'),
    data,
  });
}

export async function productCheaper(data: FormData) {
  return makeRequest<FormResponse>({
    method: 'POST',
    url: makeStoreApiRoute('forms/product/cheaper'),
    data,
  });
}

export async function productBargain(data: FormData) {
  return makeRequest<FormResponse>({
    method: 'POST',
    url: makeStoreApiRoute('forms/product/bargain'),
    data,
  });
}

export async function callMe(data: FormData) {
  return makeRequest<FormResponse>({
    method: 'POST',
    url: makeStoreApiRoute('forms/call-me'),
    data,
  });
}

export async function productQuickOrder(data: FormData) {
  return makeRequest<FormResponse>({
    method: 'POST',
    url: makeStoreApiRoute('forms/product/quick-order'),
    data,
  });
}

export async function productCredit(data: FormData) {
  return makeRequest<FormResponse>({
    method: 'POST',
    url: makeStoreApiRoute('forms/product/credit'),
    data,
  });
}

export async function calculateInstallment(data: FormData) {
  return makeRequest<FormResponse>({
    method: 'POST',
    url: makeStoreApiRoute('forms/calculate-installment'),
    data,
  });
}

export async function calculateInstallmentWork(data: FormData) {
  return makeRequest<FormResponse>({
    method: 'POST',
    url: makeStoreApiRoute('forms/calculate-installment-work'),
    data,
  });
}

export async function projectingRequest(data: FormData) {
  return makeRequest<FormResponse>({
    method: 'POST',
    url: makeStoreApiRoute('forms/projecting-request'),
    data,
  });
}

export async function storePartners(data: FormData) {
  return makeRequest<FormResponse>({
    method: 'POST',
    url: makeStoreApiRoute('forms/partners/store'),
    data,
  });
}
